let config = null;

export async function loadConfig() {
    if (config) return config;

    const response = await fetch('/variaveis.json');
    if (!response.ok) {
        throw new Error('Erro ao carregar variaveis.json');
    }
    config = await response.json();
    return config;
}

export function getConfig() {
    if (!config) {
        throw new Error('Config ainda não carregada');
    }
    return config;
}

export function getApiUrlSync() {
    return config?.API_URL ?? null;
}